export const CATEGORY_STYLES = {
  ProductUpdate: 'bg-blue-100 text-blue-800',
  Maintenance: 'bg-amber-100 text-amber-800',
  Security: 'bg-red-100 text-red-800',
  Training: 'bg-purple-100 text-purple-800',
  General: 'bg-gray-100 text-gray-700',
};

export const PRIORITY_STYLES = {
  Low: 'bg-gray-100 text-gray-700',
  Medium: 'bg-yellow-100 text-yellow-800',
  High: 'bg-orange-100 text-orange-800',
  Critical: 'bg-red-100 text-red-800',
};

export const CATEGORY_LABELS = {
  ProductUpdate: 'Product Update',
  Maintenance: 'Maintenance',
  Security: 'Security',
  Training: 'Training',
  General: 'General',
};

export const ANNOUNCEMENT_CATEGORIES = [
  'ProductUpdate',
  'Maintenance',
  'Security',
  'Training',
  'General',
];

export const ANNOUNCEMENT_PRIORITIES = ['Low', 'Medium', 'High', 'Critical'];

export const TARGETING_MODES = [
  { value: 'AllOrganizations', label: 'All organizations' },
];

/** User's local IANA timezone for displaying API instants (publishAt, etc.). */
export const ANNOUNCEMENT_LOCAL_TZ =
  typeof Intl !== 'undefined'
    ? Intl.DateTimeFormat().resolvedOptions().timeZone
    : undefined;

const ANNOUNCEMENT_DATE_FORMAT_OPTIONS = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  timeZone: ANNOUNCEMENT_LOCAL_TZ,
};

const ANNOUNCEMENT_DATETIME_FORMAT_OPTIONS = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
  timeZone: ANNOUNCEMENT_LOCAL_TZ,
};

export const EMPTY_ANNOUNCEMENT_FORM = {
  title: '',
  summary: '',
  body: '',
  category: 'ProductUpdate',
  priority: 'High',
  targetingMode: 'AllOrganizations',
  publishImmediately: true,
  primaryActionLabel: '',
  primaryActionUrl: '',
  attachments: [],
  screenshotUrl: '',
  screenshotPreviewUrl: '',
};

/** Resolve publish date from API field variants (publishAt, publishedAt, createdAt). */
export function getAnnouncementPublishDate(announcement) {
  if (!announcement) return null;
  return (
    announcement.publishAt ??
    announcement.PublishAt ??
    announcement.publishedAt ??
    announcement.PublishedAt ??
    announcement.publishDate ??
    announcement.PublishDate ??
    announcement.createdAt ??
    announcement.CreatedAt ??
    null
  );
}

export function formatAnnouncementDate(isoString) {
  if (isoString == null || isoString === '') return '—';
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', ANNOUNCEMENT_DATE_FORMAT_OPTIONS);
}

export function formatAnnouncementDateTime(isoString) {
  const value = isoString ?? null;
  if (value == null || value === '') return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString('en-US', ANNOUNCEMENT_DATETIME_FORMAT_OPTIONS);
}

export function formatAnnouncementPostedLabel(announcement) {
  return formatAnnouncementDate(getAnnouncementPublishDate(announcement));
}

export function getUpdatesPath() {
  const role = localStorage.getItem('userRole');
  if (role === 'client') return '/client/updates';
  return '/midwife/updates';
}

export function hasReadState(announcement) {
  return (
    announcement &&
    (announcement.isRead !== undefined || announcement.readAt != null)
  );
}
